/**
 * FILE: haptics.js
 * PURPOSE: Global tactile feedback (vibration) engine.
 */

const STORAGE_KEY = 'haptics_enabled';

export const isHapticsEnabled = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === null ? true : saved === 'true';
};

export const setHapticsEnabled = (enabled) => {
  localStorage.setItem(STORAGE_KEY, String(enabled));
};

export const haptics = {
  /**
   * Triggers a subtle vibration, unless the user has turned tactile feedback off
   * in Preferences.
   * Uses 10ms for a "tactile click" feel.
   */
  vibrate: (pattern = 10) => {
    if (!isHapticsEnabled()) return;
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      try {
        navigator.vibrate(pattern);
      } catch (e) {
        // Silent fail on platforms that don't support it or if it's blocked
      }
    }
  },

  /**
   * Predefined tactile patterns
   */
  impact: () => haptics.vibrate(10), // Subtle click
  medium: () => haptics.vibrate(25), // Medium knock
  heavy: () => haptics.vibrate([40, 30, 40]), // Strong notification
  error: () => haptics.vibrate([50, 100, 50]), // Error buzz
};
